// extracted by mini-css-extract-plugin
export default {"container":"sJtlbvK4hASWe8fkR8CI","headline":"tjDKK0HB6Nt1JNEkLynW"};